import {find} from 'lodash';
import React, {CSSProperties, FunctionComponent, useState} from 'react';
import Dropzone from 'react-dropzone';
import {useDispatch} from 'react-redux';
import swal from 'sweetalert2';
import {getEndpoint} from '../../../../helpers/endpoint';

interface AvatarSelectProps {
  options: Array<{imageUrl: string; label: string}>;
  onChange: (imageUrl: string) => void;
  value: string | undefined;
}

const Styles: Record<string, CSSProperties> = {
  container: {
    position: 'relative',
  },
  select: {
    width: 236,
    height: 40,
    cursor: 'pointer',
    border: '1px solid #D8DAE8',
    borderRadius: 4,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 16,
  },
  optionsContainer: {
    position: 'absolute',
    top: 42,
    width: 236,
    cursor: 'pointer',
    border: '1px solid #D8DAE8',
    borderRadius: 4,
    backgroundColor: 'white',
    boxShadow: '0px 0px 4px #00000029',
    paddingTop: 16,
    paddingBottom: 16,
    zIndex: 1,
  },
  option: {
    width: 234,
    height: 48,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
  },
  image: {
    width: 32,
    height: 32,
    marginRight: 8,
  },
  optionSelected: {
    backgroundColor: '#4054CC14',
    color: '#4054CC',
    fontWeight: 'bold',
  },
};

export const postImageUpload = (
  file: File,
  onSuccess: (imageUrl: string) => void,
) => {
  const formData = new FormData();
  formData.append('file', file);
  return (_dispatch, getState) => {
    fetch(getEndpoint('postImageUpload'), {
      method: 'POST',
      headers: {Authorization: getState().authentication.token},
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong with: "${data.error}"<br/>`,
          });
        } else {
          onSuccess(data.url);
        }
      })
      .catch(error => {
        swal({
          title: `Oops...`,
          type: 'error',
          html: `Something went wrong with: "${error}"<br/>`,
        });
      });
  };
};

export const AvatarSelect: FunctionComponent<AvatarSelectProps> = ({
  options,
  onChange,
  value,
}) => {
  const dispatch = useDispatch();
  const [opened, setOpened] = useState(false);
  return (
    <div style={Styles.container}>
      <div onClick={() => setOpened(state => !state)} style={Styles.select}>
        {find(options, {imageUrl: value})?.label ||
          (!value && 'Select Avatar') ||
          (value && 'Custom imageUrl')}
        <i style={{position: 'absolute', right: 16}} className="fa fa-sort" />
      </div>
      {opened && (
        <div style={Styles.optionsContainer}>
          {options.map(option => (
            <div
              onClick={() => {
                onChange(option.imageUrl);
                setOpened(false);
              }}
              style={{
                ...Styles.option,
                ...(value === option.imageUrl && Styles.optionSelected),
              }}>
              <img style={Styles.image} src={option.imageUrl} alt="" />
              <div>{option.label}</div>
            </div>
          ))}
          <Dropzone
            style={{...Styles.option, ...{color: '#4054CC'}}}
            onDrop={acceptedFiles => {
              const onSuccess = (imageUrl: string) => {
                onChange(imageUrl);
                setOpened(false);
              };
              dispatch(postImageUpload(acceptedFiles[0], onSuccess));
            }}>
            Personnaliser l’avatar
          </Dropzone>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/NotificationEditor/components/AvatarSelect/index.tsx